module.exports = __webpack_public_path__ + "img/RotatingAlarm.4616be8a.svg";